import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["gap"];
import { LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { CreditTileModal } from '../Usage/CreditTile';
import { CreditUpdatedLabel } from '../CreditUpdatedLabel';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { UsageSection } from '../Usage/UsageSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BulkUsage = _ref => {
  let {
      gap = 'space-xs'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    updatedAt,
    creditsPolicy
  } = useEnrichmentCredits();
  const hasHubspotCredits = creditsPolicy.hubspotCredits();
  if (hasHubspotCredits) {
    return /*#__PURE__*/_jsx(UsageSection, {});
  }
  return /*#__PURE__*/_jsxs(LayoutSpaceVertical, Object.assign({}, rest, {
    gap: gap,
    children: [/*#__PURE__*/_jsx(CreditTileModal, {}), /*#__PURE__*/_jsx(CreditUpdatedLabel, {
      updatedAt: updatedAt
    })]
  }));
};